import React from 'react';

import { createDefaultTyrann } from '@apis/common';
import { Layout } from '@components/Layout';
import { useMutation } from '@hooks/useMutation';
import * as t from 'io-ts';

const userApis = createDefaultTyrann({
  '/login/': {
    post: {
      body: t.type({
        email: t.string,
        password: t.string,
      }),
      response: {
        200: t.type({
          key: t.string,
        }),
        // 400: t.type({
        //   non_field_errors: h.omittable(t.array(t.string)),
        // }),
      },
    },
  },
  '/not-found/': {
    post: {
      response: {
        200: t.type({
          key: t.string,
        }),
        // 400: t.type({
        //   non_field_errors: h.omittable(t.array(t.string)),
        // }),
      },
    },
  },
});

const useUser = () => {
  return useMutation(async () => {
    return userApis
      .post('/login/', {
        body: {
          email: 'wangchenyu2017@gmail.com',
          password: '114514',
        },
      })
      .then((r) => r[200]!);
  });
};

const useNotFound = () => {
  return useMutation(async () => {
    return userApis.post('/not-found/', {}).then((r) => r[200]!);
  });
};

export const TestPost400 = () => {
  const user = useUser();
  const notFound = useNotFound();

  return (
    <Layout title="TestPost400">
      This should let sentry capture detailed error messages.
      <button onClick={() => user.mutateAsync()}>user</button>
      <button onClick={() => notFound.mutateAsync()}>notFound</button>
      <button
        onClick={() => {
          throw new Error('TestClickError');
        }}
      >
        TestClickError
      </button>
    </Layout>
  );
};
